import { gql } from "@apollo/client";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";

export const EVENT_REGISTRATION_QUERY = gql`
  query GetEventRegistration($id: ID!) {
    eventRegistration(id: $id) {
      id
      registeredAt
      canceledAt
      event {
        id
        slug
        eventType
        activityType
        title
        waitlistEnabled
        customFields
        startsAt
        registrationCloseAt
      }
      person {
        pgaId
        firstName
        lastName
        profilePhoto
        email
        mainProgramType {
          name
        }
        addresses {
          addressType
          address1
          address2
          city
          state
          postalCode
        }
        phoneNumbers {
          phoneNumber
          phoneFormatted
          phoneType
          phoneCountry
        }
      }
      sessions {
        duration
        endsAt
        startsAt
        title
      }
      customFields {
        adaAccomodations
        additionalGuests
        dateOfBirth
        disclaimer
        gender
      }
      order {
        id
        updatedAt
        status
        totalPaid
        balance
        paymentStatus
      }
      submission {
        document {
          name
          createdAt
          url
        }
      }
      notes {
        ...CRMNoteFields
      }
    }
  }

  ${CRM_NOTE_FIELDS_FRAGMENT}
`;
